import axios from "axios";
import {
    createMerchOrderSupabase,
    getMerchOrderSupabase,
    isSupabaseConfigured,
} from "@/lib/merchOrdersSupabase";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Create order — Supabase when configured, else Mongo API. */
export async function createMerchOrder(payload) {
    if (isSupabaseConfigured()) {
        return createMerchOrderSupabase(payload);
    }
    const { data } = await axios.post(`${API}/merch/orders`, payload);
    return data;
}

export async function getMerchOrder(orderId) {
    if (isSupabaseConfigured()) {
        return getMerchOrderSupabase(orderId);
    }
    const { data } = await axios.get(`${API}/merch/orders/${orderId}`);
    return data;
}

/** Send WhatsApp receipt — PHP by default; Python API only if no PHP URL and BACKEND_URL set. */
export async function notifyMerchReceiptPaid(order) {
    const { sendMerchWhatsAppReceipt } = await import("@/lib/whatsappReceipt");

    try {
        await sendMerchWhatsAppReceipt(order);
        return;
    } catch (phpErr) {
        console.warn("PHP WhatsApp receipt:", phpErr.message);
    }

    if (!process.env.REACT_APP_BACKEND_URL) {
        console.error(
            "WhatsApp receipt failed. Wire sendWhatsAppReceipt.php or set REACT_APP_WHATSAPP_RECEIPT_URL."
        );
        return;
    }

    try {
        await axios.post(`${API}/merch/orders/notify-receipt`, {
            id: order.id,
            customer_name: order.customer_name,
            whatsapp: order.whatsapp,
            color: order.color,
            packs: order.packs,
            cups: order.cups,
            cup_teams: order.cup_teams || [],
            total_kes: order.total_kes,
            mpesa_receipt: order.mpesa_receipt || order.mpesacode,
            external_reference: order.external_reference,
        });
    } catch (err) {
        console.error("WhatsApp receipt notify failed:", err?.response?.data || err.message);
    }
}
